import type { RouteRecordRaw } from 'vue-router'

export const agreementTemplatesRoutes: RouteRecordRaw[] = [
  {
    path: '/masters/agreement-templates',
    name: 'AGREEMENT_TEMPLATES',
    component: () => import('./AgreementTemplatesPage.vue'),
    meta: { requiresAuth: true, permission: 'super_admin' },
  },
]
